import React from "react";
import "../../assets/scss/app.scss";
import {BrowserRouter, Router} from "react-router-dom";
import history from "../../history";
import {I18nextProvider} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import i18next from "i18next";
import {config as i18nextConfig} from "../../translations";
import Routes from "./Routes/";

i18next.use(LanguageDetector).init(i18nextConfig);

const App = () => {

    return (
        <BrowserRouter>
            <I18nextProvider i18n={i18next}>
                <Router history={history}>
                    <React.StrictMode>
                        <Routes/>
                    </React.StrictMode>
                </Router>
            </I18nextProvider>
        </BrowserRouter>
    );
}

export default App;
